var AbstractTracker = require("app/Analytics/AbstractTracker"),
    config          = require("app/config"),
    deepEqual       = require("fast-deep-equal"),
    get             = require("object-path").get,
    kind            = require("enyo/kind");

module.exports = kind(/** @lends  app.Analytics.TikTokPixel.prototype */ {

    /**
     * @private
     */
    name: "app.Analytics.TikTokPixel",

    /**
     * @private
     */
    kind: AbstractTracker,

    /**
     * Whether the tracker is form an IAB Vendor.
     */
    isNonIABVendor: true,

    /**
     * Cached copy of consent data, used to detect consent changes.
     *
     * @private
     */
    consent: null,

    // Vendor Transparency and Consent
    // ----------------

    /**
     * Respond to changes in consent.
     *
     * @private
     */
    onNonIABConsentDataChange: function() {
        var $privacyService = this.app.$.privacyService,
            consent         = $privacyService.get("nonIABConsentData"),
            consentChanged  = !deepEqual(this.consent, consent);

        // Update consent state
        if (consentChanged) {
            this.consent = consent;
        }
        else {
            return;
        }

        // We are not responsible for loading ourselves
        if (get(config, "tikTokPixel.loader", null) !== "self") {
            return;
        }

        // We aren't ready yet, but are allowed to load.
        if (!this.isReady && this.hasLoadConsent()) {
            this.load();
        }

        // We are ready, but consent has just been revoked.
        else if (this.isReady && !this.hasLoadConsent()) {
            this.app.$.router.reload();
        }
    },

    // Loading
    // ----------------

    /**
     * @returns  {boolean}  Whether we have consent to load the TikTok
     * @private
     */
    hasLoadConsent: function() {
        var $privacyService   = this.app.$.privacyService,
            nonIABConsentData = $privacyService.get("nonIABConsentData");

        // Bypass parameter set
        if ($privacyService.shouldBypassConsent()) {
            return true;
        }

        // Consent for 'analytics' purpose required
        else {
            return nonIABConsentData
                && nonIABConsentData.accepted
                && Array.isArray(nonIABConsentData.accepted)
                && nonIABConsentData.accepted.includes("analytics");
        }
    },

    /**
     * @return {string|null} The loader
     * @public
     */
    getLoader: function() {
        return get(config, "tikTokPixel.loader", null);
    },

    /**
     * Mostly the same code as the incoming snippet (hence the obtuse code),
     * modified only to double-check for sufficient configuration and to track
     * loading state.
     *
     * @private
     */
    load: function() {
        // TikTokPixel not enabled
        if (!get(config, "tikTokPixel.enabled", false)
            || get(config, "tikTokPixel.loader", null) !== "self"
            || !get(config, "tikTokPixel.id", false)) {
            return;
        }

        // Bail if already loaded
        if (this.isLoaded) {
            return;
        }

        /* eslint-disable */
        // TikTok Pixel.
        !(function(w, d, t, tracker) {
            // Part 1
            w.TiktokAnalyticsObject = t;
            var ttq                 = w[t] = w[t] || [];

            ttq.methods = ["page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias", "group", "enableCookie", "disableCookie"];

            ttq.setAndDefer = function(t, e) {
                t[e] = function() {
                    t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
                };
            };

            for (var i = 0; i < ttq.methods.length; i++) {
                ttq.setAndDefer(ttq, ttq.methods[i]);
            }

            ttq.instance = function(t) {
                for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++) {
                    ttq.setAndDefer(e, ttq.methods[n]);
                }

                return e;
            };

            ttq.load = function(e, n) {
                var i = "https://analytics.tiktok.com/i18n/pixel/events.js";

                ttq._i       = ttq._i || {};
                ttq._i[e]    = [];
                ttq._i[e]._u = i;
                ttq._t       = ttq._t || {};
                ttq._t[e]    = Number(new Date());
                ttq._o       = ttq._o || {};
                ttq._o[e]    = n || {};

                var o     = document.createElement("script");
                o.type    = "text/javascript";
                o.async   = !0;
                o.src     = i + "?sdkid=" + e + "&lib=" + t;
                // These callbacks are our own
                o.onload  = tracker.onLoad;
                o.onerror = tracker.onLoadError;

                var a = document.getElementsByTagName("script")[0];
                a.parentNode.insertBefore(o, a);
            };

            // Part 2
            ttq.load(tracker.tikTokPixelId);
            ttq.page();
        }(
            window,
            document,
            "ttq",
            // This object is our own addition, used to pass some info into the
            // pixel code
            {
                tikTokPixelId: get(config, "tikTokPixel.id", false),
                onLoad:        this.onLoad,
                onLoadError:   this.onLoadError
            }
        ));
        /* eslint-enable */
    },

    /**
     * @returns  {boolean}  `true` when ready, `false` otherwise.
     * @private
     */
    verifyReadiness: function() {
        return typeof ttq !== "undefined" ? true : false;
    },

    /**
     * @private
     */
    onReady: kind.inherit(function(sup) {
        return function() {
            // Consent has been revoked while we were getting ready
            if (get(config, "tikTokPixel.loader", null) === "self"
                && !this.hasLoadConsent()) {
                this.app.$.router.reload();

                return;
            }

            sup.apply(this, arguments);
        };
    })

});
